import React, { useEffect, useRef, useState, useContext } from "react";
import {
    Grid,
    TextField,
    Typography,
    Paper,
    Switch,
    FormControlLabel,
    Container,
    Box,
    TextareaAutosize,
    Button,
    FormGroup,
    CircularProgress,
} from "@mui/material";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L, { setOptions } from "leaflet";
import Textarea from "@mui/joy/Textarea";
import "leaflet/dist/leaflet.css";
import LocationMarker from "./../../ui/Map";
import Dropdown from "./../../ui/Dropdown";
import { ImageIcon, VideoIcon, ImageUp, MonitorUp } from "lucide-react";
import { Mutation, useMutation, useMutationState } from "@tanstack/react-query";
import { postDeveloperData, postProjectEdit, postRealEstateData, projectData, useFetchData } from "../../hooks/useFetchData";
import { useTranslation } from "react-i18next";

import Modall from "./../../ui/Modal";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { redirect, useNavigate, useParams } from "react-router-dom";
import { validationSchema } from "../../component/validation";

import "react-loading-skeleton/dist/skeleton.css";
import CustomerTestimonial from "./../../ui/Loading";
import { ToastContainer, toast } from "react-toastify";
import customIconUrl from '../../component/images/home.png'; // Replace with your actual image path
import { usecontextUser } from "../../context/usecontextUser";


let DefaultIcon = L.icon({
    iconUrl: customIconUrl,
    // shadowUrl: iconShadow,
    iconSize: [60, 60],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    // shadowSize: [41, 41],
});
export default function Project() {
    const { user } = useContext(usecontextUser)
    const { id } = useParams()

    L.Marker.prototype.options.icon = DefaultIcon;

    const { data: data2 } = useFetchData(
        "https://3dfinal.tanaghomtech.com/public/api/cities"
    );
    const { data: data1 } = useFetchData(
        `https://3dfinal.tanaghomtech.com/public/api/projects/${id}`
    );
    console.log("data2", data1);

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [markerPosition, setMarkerPosition] = useState({
        lat: 33.51328081312661,
        lng: 36.27681196925691,
    });


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const [preview, setPreview] = useState(null);
    const [previeww, setPrevieww] = useState(null);
    const [preview2, setPreview2] = useState(null);
    const [previeww2, setPrevieww2] = useState(null);
    const [previews, setPreviews] = useState([]);
    const [previewss, setPreviewss] = useState([]);
    const [previewsV, setPreviewsV] = useState([]);
    const [previewssV, setPreviewssV] = useState([]);
    const [checked, setChecked] = useState({});
    const [formDataa, setFormDataa] = useState({});
    const [open, setOpen] = useState();
    const [citytype, setCitytype] = useState([]);
    const [imageError, setImageError] = useState();
    const im = process.env.REACT_APP_IMAGE;
    const fileInputRef = useRef();
    const openFilePicker = () => {
        fileInputRef.current?.click();
    };
    const [rent, setRent] = useState(null);
    const [unit, setUnit] = useState(null);
    const {
        register,
        handleSubmit,
        control,      // <-- هنا تعريف control
        trigger,
        reset,
        getValues,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
    });
    const [originalValues, setOriginalValues] = useState({});
    useEffect(() => {
        if (data1?.data) {
            setValue("developer_name", data1.data.developer_name);
            setValue("developer_name_en", data1.data.developer_name_en);
            setValue("developer_address", data1.data.developer_address);
            setValue("developer_address_en", data1.data.developer_address_en);
            setValue("developer_description", data1.data.developer_description);
            setValue("developer_description_en", data1.data.developer_description_en);
            setValue("developer_email", data1.data.developer_email);
            setValue("developer_phone", data1.data.developer_phone);
            if (data1.data.project_image) {
                setPreview(data1.data.project_image);

            }
            if (data1.data.project_image) {
                setPreview2(data1.data.project_image);

            }
            if (data1.data.medias) {
                setPreviews(data1.data.medias);

            }
        }
    }, [data1]);
    // useEffect(() => {
    //     if (projectData) {
    //         setOriginalValues(projectData);
    //         reset(projectData); // reset useForm بالقيم الأصلية
    //     }
    // }, [projectData]);
    const handleDropdownChange = (label, value) => {
        if (label === "Offer type") {
            setUnit(value); // Update the rent state
        }
    };
    const handleDropdownChange2 = (label, value) => {
        if (label === "unit status") {
            setRent(value); // Update the rent state

        } else if (label === "Cities") {
            const selectedCity = data2?.data?.find((item) => item?.id === value);
            setCitytype(selectedCity);
            console.log(
                "selectedCity", selectedCity,
                data2?.data?.find((item) => item?.id === value)
            );
        }
    };
    // useEffect(() => {
    //     if (data1?.data) {
    //         setValue("project_name", data1?.data?.project_name);


    //     }
    // }, [data1]);

    useEffect(() => {

        handleDropdownChange();
        console.log(typeof unit, unit);
        handleDropdownChange2();
        console.log(typeof rent, rent);
    }, [unit, rent]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value !== undefined) {
            setFormDataa((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };
    const handleswitch = (e) => {
        const { name, checked: isChecked } = e.target;
        setChecked((prev) => ({
            ...prev,
            [name]: isChecked,
        }));
    };


    const handleImageUpload2 = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
            setPreview2(URL.createObjectURL(file));
            setPrevieww2(file);
        }
    };

    const handleImageUploadvideo = (event) => {
        const files = Array.from(event.target.files);

        // ✅ Filter only video files
        const videoFiles = files.filter((file) => file.type.startsWith("video/"));
        const videoPreviews = videoFiles.map((file) => URL.createObjectURL(file));
        setPreviewssV(videoFiles); // ✅ use this in rendering
        setPreviewsV((prev) => [...prev, ...videoPreviews]); // add new previews to existing ones
    };

    const selectedRegion = citytype?.regions?.find(
        r => r.id === data1?.data?.region_id
    );
    console.log(data1?.data?.region_id);

    // const mutation = useMutation({
    //     mutationFn: projectData,
    //     onSuccess: (data) => {
    //         console.log("Posted successfully", data.data.post.post_reference);
    //         setData(data.data.post.post_reference);
    //     },
    //     onError: (error) => {
    //         console.error("Posting failed", error.message);
    //     },
    // });

    const handleOpen = async () => {
        const valid = await trigger([
            "address",
        ]);
        if (valid) {
            setOpen(true);
        } else {
            toast.error("complete all required input");
        }
    };
    const mutation = useMutation({
        mutationFn: (formData) => {
            if (id) {
                formData.append("_method", "PUT");
                navigate("/management")
                return postProjectEdit(formData, id);
            }

            return projectData(formData);
        },
    });



    // --------------------- Upload Handlers ---------------------
    const handleImageUploads = (e) => {
        const files = Array.from(e.target.files).filter((f) =>
            f.type.startsWith("image/")
        );
        setPreviews(files.map((f) => URL.createObjectURL(f)));
        setValue("images", files);
    };

    //   const handleVideoUploads = (e) => {
    //     const files = Array.from(e.target.files).filter((f) =>
    //       f.type.startsWith("video/")
    //     );
    //     setPreviewssV(files.map((f) => URL.createObjectURL(f)));
    //     setValue("videos", files);
    //   };

    // --------------------- Handle Submit ---------------------
    // نفترض عندك initialValues من الـ API محفوظة في state
    // const [initialValues, setInitialValues] = useState({});

    const handleSubmitProject = async () => {
        setLoading(true);
        try {
            const values = getValues();
            console.log("values", values);

            // ✅ validate with Yup
            if (!id) {
                await validationSchema.validate(values, { abortEarly: false });
            }


            const formData = new FormData();

            formData.append("user_id", localStorage.getItem("userId"));

            // الحقول العادية (فقط لو اختلفت عن الأصلية)
            Object.entries(values).forEach(([key, value]) => {
                if (["project_image", "images", "videos", "unit-plan"].includes(key)) return;

                // ⛔ لا تضيف أي قيمة null أو undefined أو فارغة
                if (value !== undefined && value !== null && value !== "") {
                    formData.append(key, value);
                }
            });



            // الإحداثيات (مثال: تبعتهم بس لو اختلفوا)
            if (
                markerPosition.lat !== values.latitude ||
                markerPosition.lng !== values.longitude
            ) {
                formData.set("latitude", markerPosition.lat);
                formData.set("longitude", markerPosition.lng);
            }

            // الصورة الرئيسية
            if (values.project_image instanceof File) {
                formData.append("project_image", values.project_image);
            }

            // الصور المتعددة
            if (Array.isArray(values.images) && values.images.length > 0) {
                values.images.forEach((file) => formData.append("images[]", file));
            }

            // الفيديوهات
            if (Array.isArray(values.videos) && values.videos.length > 0) {
                values.videos.forEach((file) => formData.append("videos[]", file));
            }

            // ✅ Call mutate with success/error handlers
            mutation.mutate(formData);
        } catch (err) {
            setLoading(false);

            if (err.name === "ValidationError") {
                console.error("Validation errors:", err.errors);
                toast.error(err.errors.join(" , ")); // عرض جميع الأخطاء
            } else {
                console.error("Unexpected error:", err);
                toast.error("Something went wrong. Please try again.");
            }
        }
    };
    console.log("rr", previews);

    return (
        <form id="project-form" onSubmit={handleSubmit(handleSubmitProject)}>
            {loading ? (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "100px",
                    }}
                >
                    <CustomerTestimonial />
                </div>
            ) : (
                <Container sx={{ overflowY: "auto", mb: 10 }}>
                    <Paper
                        elevation={10}
                        style={{
                            backgroundColor: "#fff",
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            direction: t("directions.dir"),
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                mt: 2,
                                mb: 2,
                                boxShadow:
                                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                padding: "8px",
                                backgroundColor: "#f3efee",
                                display: "inline-block",
                                width: "auto",
                                fontWeight: "bold",
                                fontFamily: "oswald,cairo",
                                //   right:'0',
                                //   position:'absolute'
                            }}
                        >
                            {t("AddUnit.Step1")}
                        </Typography>
                        <div style={{ padding: "24px" }}>
                            <Box
                                sx={{
                                    width: "100%",
                                    gap: 2,
                                    maxWidth: "100%",
                                    display: "flex",
                                    mb: 3,
                                }}
                            >
                                <ToastContainer />


                                <TextField
                                    fullWidth
                                    {...register("project_name")}
                                    name="project_name"
                                    value={formDataa.project_name || data1?.data?.project_name}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.project_name")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    error={!!errors.developer_name}
                                    helperText={errors.developer_name?.message}
                                />
                                <TextField
                                    {...register("project_name_en")}
                                    fullWidth
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    value={formDataa.project_name_en || data1?.data?.project_name_en}
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddCar.project_name_en")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    id="fullWidth"
                                    name="project_name_en"
                                    error={!!errors.developer_name_en}
                                    helperText={errors.developer_name_en?.message}
                                />
                            </Box>
                            <Grid item xs={12} sx={{ mb: 3 }}>
                                <Typography
                                    sx={{ fontFamily: "oswald,cairo" }}
                                    variant="h5"
                                    gutterBottom
                                >
                                    {t("AddUnit.map")}
                                </Typography>
                                <MapContainer
                                    center={[markerPosition.lat || data1?.data?.latitude, markerPosition.lng || data1?.data?.longitude]}
                                    zoom={13}
                                    style={{ height: 400, borderRadius: 10 }}
                                >
                                    <TileLayer
                                        attribution="&copy; OpenStreetMap contributors"
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <LocationMarker
                                        position={markerPosition}
                                        setPosition={setMarkerPosition}
                                    />
                                </MapContainer>
                            </Grid>
                            <Box
                                sx={{
                                    width: "100%",
                                    gap: 2,
                                    maxWidth: "100%",
                                    display: "flex",
                                    mb: 3,
                                }}
                            >
                                {/* <Controller
                                    name="contract_id"
                                    control={control}


                                    render={({ field, fieldState }) => (
                                        <Dropdown
                                            label={t("AddUnit.contract")}
                                            url="contracts"
                                            value={field.value || data1?.data?.contract_id}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )}
                                />{" "} */}
                                <Controller
                                    name="city_id"
                                    control={control}
                                    rules={{ required: "City is required" }}
                                    render={({ field, fieldState }) => (
                                        <Dropdown
                                            label={t("AddUnit.Cities")}
                                            url="cities"
                                            value={field.value || data1?.data?.city_id}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                handleDropdownChange2("Cities", value);
                                            }}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}
                                />
                                {citytype && (
                                    <Controller
                                        name="region_id"
                                        control={control}
                                        rules={{ required: "region is required" }}
                                        render={({ field, fieldState }) => (
                                            <Dropdown

                                                options={citytype?.regions}
                                                label={t("AddUnit.region")}
                                                value={field.value || data1?.data?.region_id} // تمرير الكائن كامل
                                                onChange={field.onChange}
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                )}
                            </Box>
                            <Box
                                sx={{
                                    width: "100%",
                                    gap: 2,
                                    maxWidth: "100%",
                                    display: "flex",
                                    mb: 3,
                                }}
                            >
                                <TextField
                                    fullWidth
                                    {...register("address")}
                                    id="fullWidth"
                                    name="address"
                                    InputLabelProps={{ shrink: true }}
                                    value={formDataa.address || data1?.data?.address}
                                    onChange={handleChange}
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddUnit.address")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    error={!!errors.address}
                                    helperText={errors.address?.message}
                                />
                                <TextField
                                    {...register("address_en")}
                                    fullWidth
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    value={formDataa.address_en || data1?.data?.address_en}
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddUnit.address_en")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            ></span>
                                        </span>
                                    }
                                    id="fullWidth"
                                    name="address_en"
                                />
                            </Box>
                            <Box sx={{ mb: 2 }}>
                                <label
                                    htmlFor="description"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: "400",
                                        color: "gray",
                                    }}
                                >
                                    {t("AddUnit.description")}{" "}
                                    <span
                                        style={{ color: "red", fontSize: "20px", marginLeft: 4 }}
                                    >
                                        *
                                    </span>
                                </label>
                                <label
                                    style={{
                                        fontWeight: "300",
                                        fontWeight: "300",
                                        color: "gray",
                                    }}
                                >
                                    {t("AddUnit.least100")}
                                </label>
                                <Textarea
                                    id="project_description"
                                    name="project_description"
                                    minRows={4}
                                    size="lg"
                                    InputLabelProps={{ shrink: true }}
                                    {...register("project_description")}
                                    error={!!errors.project_description}
                                    value={formDataa.project_description || data1?.data?.project_description}
                                    onChange={handleChange}
                                />
                                {errors.project_description && (
                                    <Typography variant="caption" color="error">
                                        {errors.project_description.message}
                                    </Typography>
                                )}

                                {/* {formErrors?.description && (
                                    <p style={{ color: 'red', fontSize: '0.8rem', marginTop: '4px' }}>
                                        {formErrors.description}
                                    </p>
                                )} */}

                                <Box sx={6}></Box>
                            </Box>
                            <Box sx={12}>
                                <label style={{ fontWeight: "400", color: "gray" }}>
                                    {t("AddUnit.project_description_en")}
                                </label>
                                <Textarea
                                    xs={5}
                                    minRows={4}
                                    {...register("project_description_en")}
                                    size="lg"
                                    label="project_description_en"
                                    InputLabelProps={{ shrink: true }}
                                    name="project_description_en"
                                    value={formDataa.project_description_en || data1?.data?.project_description_en}
                                    onChange={handleChange}
                                />
                                <p>{errors.project_description_en?.message}</p>
                                <Box sx={6}></Box>
                            </Box>
                        </div>
                    </Paper>
                    <Paper
                        elevation={10}
                        style={{
                            backgroundColor: "#fff",
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            direction: t("directions.dir"),
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                mt: 2,
                                mb: 2,
                                boxShadow:
                                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                padding: "8px",
                                backgroundColor: "#f3efee",
                                display: "inline-block",
                                width: "auto",
                                fontWeight: "bold",
                                fontFamily: "oswald,cairo",
                                //   right:'0',
                                //   position:'absolute'
                            }}
                        >
                            {t("AddUnit.Step2")}
                        </Typography>
                        <div style={{ padding: "24px" }}>
                            <Box
                                sx={{
                                    width: "100%",
                                    gap: 2,
                                    maxWidth: "100%",
                                    display: "flex",
                                    mb: 3,
                                }}
                            >
                            </Box>
                            <Box
                                sx={{
                                    width: "100%",
                                    gap: 2,
                                    maxWidth: "100%",
                                    display: "flex",
                                    mb: 3,
                                }}
                            >
                                <Controller
                                    name="developer_id"
                                    control={control}
                                    rules={{ required: "condition is required" }}
                                    render={({ field, fieldState }) => (
                                        <Dropdown
                                            label={t("AddUnit.developers")}
                                            url="developers"
                                            value={field.value || data1?.data?.developer_id}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}
                                />
                                <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddUnit.progress")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    {...register("progress")}
                                    id="fullWidth"
                                    name="progress"
                                    value={formDataa.progress || data1?.data?.progress}
                                    onChange={handleChange}
                                    error={!!errors.progress}
                                    helperText={errors.progress?.message}
                                />
                                <TextField
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    label={
                                        <span style={{ display: "flex", alignItems: "center" }}>
                                            {t("AddUnit.floors_count")}{" "}
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontSize: "25px",
                                                    marginBottom: "-5px",
                                                }}
                                            >
                                                *
                                            </span>
                                        </span>
                                    }
                                    {...register("floors_count")}
                                    id="fullWidth"
                                    name="floors_count"
                                    value={formDataa.floors_count || data1?.data?.floors_count}
                                    onChange={handleChange}
                                    error={!!errors.floors_count}
                                    helperText={errors.floors_count?.message}
                                />
                            </Box>
                        </div>
                    </Paper>
                    <Paper
                        elevation={10}
                        style={{
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            display: "flex",
                        }}
                    >
                        <Box
                            sx={{
                                width: "100%",
                                gap: 2,
                                maxWidth: "100%",
                                mb: 3,
                                direction: t("directions.dir"),
                            }}
                        >
                            <Typography
                                variant="h4"
                                sx={{
                                    mt: 2,
                                    mb: 2,
                                    boxShadow:
                                        "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                    padding: "8px",
                                    backgroundColor: "#f3efee",
                                    display: "inline-block",
                                    width: "auto",
                                    fontWeight: "bold",
                                    fontFamily: "oswald,cairo",
                                    //   right:'0',
                                    //   position:'absolute'
                                }}
                            >
                                {t("AddUnit.Step3")}
                            </Typography>
                            <FormGroup sx={{ padding: "16px" }}>
                                <Grid container spacing={2}>
                                    <Grid size={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    name="elevator"
                                                    checked={checked.elevator|| data1?.data?.elevator}
                                                    onChange={handleswitch}
                                                />
                                            }
                                            label={
                                                <Typography
                                                    sx={{ fontFamily: "Oswald,Cairo" }}
                                                    fontSize={15}
                                                >
                                                    {t("AddUnit.elevator")}
                                                </Typography>
                                            }
                                        />

                                    </Grid>
                                    <Grid size={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    name="solar_elevator"
                                                    checked={checked.solar_elevator || data1?.data?.solar_elevator}
                                                    onChange={handleswitch}
                                                />
                                            }
                                            label={
                                                <Typography
                                                    sx={{ fontFamily: "Oswald,Cairo" }}
                                                    fontSize={15}
                                                >
                                                    {t("AddUnit.solar_elevator")}
                                                </Typography>
                                            }
                                        /></Grid>
                                    <Grid size={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    name="garden"
                                                    checked={checked.garden || data1?.data?.garden}
                                                    onChange={handleswitch}
                                                />
                                            }
                                            label={
                                                <Typography
                                                    sx={{ fontFamily: "Oswald,Cairo" }}
                                                    fontSize={15}
                                                >
                                                    {t("AddUnit.graden")}
                                                </Typography>
                                            }
                                        />
                                    </Grid>


                                    <Grid size={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    name="private_pool"
                                                    checked={checked.pool || data1?.data?.private_pool}
                                                    onChange={handleswitch}
                                                />
                                            }
                                            label={
                                                <Typography
                                                    sx={{ fontFamily: "Oswald,Cairo" }}
                                                    fontSize={15}
                                                >
                                                    {t("AddUnit.pool")}
                                                </Typography>
                                            }
                                        />
                                    </Grid>

                                    <Grid size={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    name="parking"
                                                    checked={checked.parking || data1?.data?.parking}
                                                    onChange={handleswitch}
                                                />
                                            }
                                            label={
                                                <Typography
                                                    sx={{ fontFamily: "Oswald,Cairo" }}
                                                    fontSize={15}
                                                >
                                                    {t("AddUnit.parking")}
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    name="private_beach"
                                                    sx={{ fontSize: "30px" }}
                                                    checked={checked.beach || data1?.data?.private_beach}
                                                    onChange={handleswitch}
                                                />
                                            }
                                            label={
                                                <Typography
                                                    sx={{ fontFamily: "Oswald,Cairo" }}
                                                    fontSize={15}
                                                >
                                                    {t("AddUnit.beach")}
                                                </Typography>
                                            }
                                        />
                                    </Grid>
                                    {/* <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="elevator"
                          checked={checked.elevator}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography sx={{fontFamily:"Oswald,Cairo"}} fontSize={15}>{t("AddUnit.elevator")}</Typography>
                      }
                    />
                  </Grid> */}




                                </Grid>
                            </FormGroup>
                        </Box>
                    </Paper>
                    <Paper
                        elevation={10}
                        style={{
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            direction: t("directions.dir"),
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                mt: 2,
                                mb: 2,
                                boxShadow:
                                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                padding: "8px",
                                backgroundColor: "#f3efee",
                                display: "inline-block",
                                width: "auto",
                                fontWeight: "bold",
                                fontFamily: "oswald,cairo",
                                //   right:'0',
                                //   position:'absolute'
                            }}
                        >
                            {t("AddUnit.mainimage")}{" "}
                            <span
                                style={{ color: "red", fontSize: "25px", marginBottom: "-5px" }}
                            >
                                *
                            </span>
                        </Typography>

                        <Box sx={{ p: 4 }}>
                            <Box
                                component="label"
                                sx={{
                                    width: 250,
                                    height: 180,
                                    border: "1px solid #ddd",
                                    borderRadius: 2,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#fff",
                                    overflow: "hidden",
                                }}
                            >
                                {preview ? (
                                    <img
                                        src={
                                            preview.includes("http://localhost:3000")
                                                ? preview
                                                : `https://3dfinal.tanaghomtech.com/storage/app/public/${preview}`
                                        }
                                        alt="Preview"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                ) : (
                                    <ImageUp size={64} color="black" />
                                )}
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    ref={fileInputRef}
                                    {...register("project_image", {
                                        required: "Image is required",
                                    })}
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setValue("project_image", file); // مهم جداً لإرسال الصورة
                                            setPreview(URL.createObjectURL(file)); // فقط لو حبيت تعرض preview
                                        }
                                    }}
                                />
                            </Box>
                            {errors["project_image"] && (
                                <Typography variant="h5" color="error">
                                    {errors["project_image"].message}
                                </Typography>
                            )}
                        </Box>
                    </Paper>
                    <Paper
                        elevation={10}
                        style={{
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            direction: t("directions.dir"),
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                mt: 2,
                                mb: 2,
                                boxShadow:
                                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                padding: "8px",
                                backgroundColor: "#f3efee",
                                display: "inline-block",
                                width: "auto",
                                fontWeight: "bold",
                                fontFamily: "oswald,cairo",
                                //   right:'0',
                                //   position:'absolute'
                            }}
                        >
                            {t("AddUnit.unitplan")}
                        </Typography>
                        <Box sx={{ p: 4 }}>
                            <Box
                                {...register("unit-plan")}
                                component="label"
                                htmlFor="unit-plan"
                                sx={{
                                    width: 250,
                                    height: 180,
                                    border: "1px solid #ddd",
                                    borderRadius: 2,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#fff",
                                    overflow: "hidden",
                                }}
                            >
                                {preview2 ? (
                                    <img
                                     src={
                                         preview2.includes("http://localhost:3000")
                                            ? preview2
                                            : `https://3dfinal.tanaghomtech.com/storage/app/public/${preview2}`
                                    }
                                        alt="Preview"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                ) : (
                                    <ImageUp size={64} color="black" />
                                )}
                                <input
                                    type="file"
                                    accept="image/*"
                                    id="unit-plan"
                                    style={{ display: "none" }}
                                    onChange={handleImageUpload2}
                                />
                            </Box>

                        </Box>

                    </Paper>
                    <Paper
                        elevation={10}
                        style={{
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            direction: t("directions.dir"),
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                mt: 2,
                                mb: 2,
                                boxShadow:
                                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                padding: "8px",
                                backgroundColor: "#f3efee",
                                display: "inline-block",
                                width: "auto",
                                fontWeight: "bold",
                                fontFamily: "oswald,cairo",
                                //   right:'0',
                                //   position:'absolute'
                            }}
                        >
                            {t("AddUnit.unitimages")}{" "}
                            <span
                                style={{ color: "red", fontSize: "25px", marginBottom: "-5px" }}
                            >
                                *
                            </span>
                        </Typography>

                        <Typography variant="h6" sx={{ color: "gray", padding: "16px" }}>
                            {t("AddUnit.least3")}
                        </Typography>
                        {previews.length > 0 && (
                            <Button
                                variant="contained"
                                sx={{ ml: "20px" }}
                                onClick={() => setPreviews("")}
                            >
                                Clear
                            </Button>
                        )}
                        <Box sx={{ p: 4 }}>
                            <Box
                                component="label"
                                htmlFor="medias"
                                sx={{
                                    width: "100%",
                                    height: 180,
                                    border: "1px solid #ddd",
                                    borderRadius: 2,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#fff",
                                    overflow: "hidden",
                                }}
                            >
                                {previews.length > 0 ? (
                                    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                        {previews.map((src1, index) => (
                                            <img
                                                key={index}
                                                src={
                                         src1.link.includes("http://localhost:3000")
                                            ? src1
                                            : `https://3dfinal.tanaghomtech.com/storage/app/public/${src1.link}`
                                    }
                                                alt="Previews"
                                                style={{
                                                    width: "30%",
                                                    height: "180px",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        ))}
                                    </Box>
                                ) : (
                                    <ImageUp size={64} color="black" />
                                )}

                                <input
                                    type="file"
                                    accept="image/*"
                                    id="images"
                                    multiple
                                    style={{ display: "none" }}
                                    {...register("images", {
                                        onChange: (e) =>
                                            handleImageUploads(
                                                e,
                                                e.target.files && e.target.files.length
                                                    ? () => { }
                                                    : () => { }
                                            ),
                                    })}
                                />
                            </Box>
                            {imageError && <p style={{ color: "red" }}>{imageError}</p>}
                            {errors.images && (
                                <p style={{ color: "red" }}>{errors.images.message}</p>
                            )}
                        </Box>
                    </Paper>
                    <Paper
                        elevation={10}
                        style={{
                            padding: 0,
                            borderRadius: 16,
                            marginTop: 16,
                            direction: t("directions.dir"),
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                mt: 2,
                                mb: 2,
                                boxShadow:
                                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                                padding: "8px",
                                backgroundColor: "#f3efee",
                                display: "inline-block",
                                width: "auto",
                                fontWeight: "bold",
                                fontFamily: "oswald,cairo",
                                //   right:'0',
                                //   position:'absolute'
                            }}
                        >
                            {t("AddUnit.unitvideos")}
                        </Typography>

                        <Box sx={{ p: 4 }}>
                            <Box
                                component="label"
                                htmlFor="videos"
                                sx={{
                                    width: "100%",
                                    height: 180,
                                    border: "1px solid #ddd",
                                    borderRadius: 2,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#fff",
                                    overflow: "hidden",
                                }}
                            >
                                {previewsV.length > 0 ? (
                                    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                        {previewsV.map((src, index) => (
                                            <video
                                                key={index}
                                                style={{
                                                    width: "30%",
                                                    height: "180px",
                                                    objectFit: "cover",
                                                }}
                                                controls
                                            >
                                                <source src={src} type="video/*" />
                                            </video>
                                        ))}
                                    </Box>
                                ) : (
                                    <MonitorUp size={64} color="black" />
                                )}
                                <input
                                    {...register("videos")}
                                    type="file"
                                    accept="video/*"
                                    id="videos"
                                    multiple
                                    style={{ display: "none" }}
                                    onChange={handleImageUploadvideo}
                                />
                            </Box>

                            <Paper>
                                <Modall
                                    handleOpen={handleOpen}
                                    open={open}
                                    setOpen={setOpen}
                                    loading={loading}
                                    handle={handleSubmitProject}
                                />
                            </Paper>
                        </Box>
                    </Paper>
                </Container>
            )}
        </form>
    );
}
